<script setup>
import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net-dt';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import axios from "axios";
import {onMounted, ref} from "vue";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const exportToExcel = (data, fileName = "export.xlsx") => {
  // 1. Obyekt massivini jadvalga aylantirish
  const worksheet = XLSX.utils.json_to_sheet(data);

  // 2. Yangi workbook yaratish va worksheet qo‘shish
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  // 3. Faylni blob qilib olish
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

  // 4. Brauzerga yuklash
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(blob, fileName);
};

DataTable.use(DataTablesCore);
const accountings = ref([])
const url = 'https://marketwave.uz/telegram/bot/json.php'
const getAccountings = async function () {
    try{
      const response = await axios.get(url, {
        headers:{
          'Accept':'application/json',
        }
      })
      accountings.value = response.data
    }catch (e) {
      console.log(e)
    }
}
onMounted(() => {
  getAccountings()
})
</script>
<template>
    <div class="p-4">
      <div class="flex justify-end">
        <button class="bg-gradient-to-t from-green-500 to-green-200 rounded-md p-2 text-black" @click="exportToExcel(accountings, 'accountings.xlsx')">Download</button>
      </div>
      <div class="overflow-x-auto" v-if="accountings.length > 0">
        <DataTable class="display" :options="{ order: [] }">
          <thead>
            <tr>
              <th class="px-1 py-2 border-b">Data</th>
              <th class="px-1 py-2 border-b">Id</th>
              <th class="px-4 py-2 border-b">Payment type</th>
              <th class="px-4 py-2 border-b">User telegram id</th>
              <th class="px-4 py-2 border-b">Full name</th>
              <th class="px-4 py-2 border-b">Username</th>
              <th class="px-4 py-2 border-b">Amount</th>
              <th class="px-4 py-2 border-b">Description</th>
              <th class="px-4 py-2 border-b">Supplier</th>
              <th class="px-4 py-2 border-b">Card number</th>
              <th class="px-4 py-2 border-b">Reason</th>
              <th class="px-4 py-2 border-b">Contract number</th>
              <th class="px-4 py-2 border-b">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(accounting, accounting_index) in accountings" :key="accounting_index"
                class="cursor-pointer" @click="router.get('/accounting-view')">
              <td class="px-1 py-2 border-b font-medium">
                <span>{{accounting.data}}</span>
              </td>
              <td class="px-1 py-2 border-b font-medium">
                <span>№ {{accounting.id}}</span>
              </td>
              <td class="px-1 py-2 border-b font-medium">
                <span>{{accounting.payment_type}}</span>
              </td>
              <td class="px-1 py-2 border-b font-medium">
                <span>{{accounting.employee_telegram_id}}</span>
              </td>
              <td class="px-1 py-2 border-b font-medium">
                <span>{{accounting.employee_full_name}}</span>
              </td>
              <td class="px-1 py-2 border-b font-medium">
                <span>{{accounting.employee_username}}</span>
              </td>
              <td class="px-1 py-2 border-b font-medium">
                <span>{{accounting.amount}}</span>
              </td>
              <td class="px-1 py-2 border-b font-medium">
                <span>{{accounting.description}}</span>
              </td>
              <td class="px-1 py-2 border-b font-medium">
                <span>{{accounting.supplier_name}}</span>
              </td>
              <td class="px-1 py-2 border-b font-medium">
                <span>{{accounting.card_number}}</span>
              </td>
              <td class="px-1 py-2 border-b font-medium">
                <span>{{accounting.reason}}</span>
              </td>
              <td class="px-1 py-2 border-b font-medium">
                <span>{{accounting.contract_number}}</span>
              </td>
              <td class="px-1 py-2 border-b font-medium">
                <span>{{accounting.status}}</span>
              </td>
            </tr>
          </tbody>
        </DataTable>
      </div>
    </div>
</template>
